import React from 'react';
import { string, arrayOf } from 'prop-types';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';

const PaymentPlanItem = ({ itemList, className }) => {
  if (itemList.length === 0) {
    return null;
  }

  return (
    <Grid
      className={className}
      align="center"
      justify="center">
      {
        itemList.map((item, index) => <GridItem span={4} key={index} >
          {item}
        </GridItem>)
      }
    </Grid>
  );
};

PaymentPlanItem.propTypes = {
  itemList: arrayOf(string),
  className: string,
};

PaymentPlanItem.defaultProps = {
  itemList: [],
};

export default PaymentPlanItem;
